import { resetSearchSelection } from '@/store.js';

// Everything SearchBar rehydrates from the URL. Location and insurance are deliberately kept:
// they are the user's context, not a selection.
const SELECTION_PARAMS = ['search', 'specialty', 'selected_professional', 'service_type', 'is_online_service'];

export const returnToSearchLanding = (history: any) => {
    const query = new URLSearchParams(history.location.search);
    SELECTION_PARAMS.forEach((param) => query.delete(param));
    history.replace({ search: query.toString() });
    resetSearchSelection();
};
